import React from 'react';
import {connect} from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import * as ResourceApi from "api/resources";
import {getAllResourcesAction} from "resources/actions";
import {filterOptionsFactory, sortOptionsFactory} from "viewOptions/factories";
import SavePaletteMessage from '../forms/CustomFields/SavePaletteMessage';
import {createResourceTypeSelector} from "resources/selectors";
import {savePaletteAction} from 'pages/EditBreak/actions';

const mapStateToProps = (state) => ({
    hasError: false,
    breakId: state.editBreak.break[state.editBreak.currentPlatform],
    formError: state.editBreak.formErrorCreatingPalette,
    successfulPaletteCreation:  state.editBreak.createPaletteSuccess
});

const mapDispatchToProps = (dispatch) => ({
    savePalette: (breakId, newPaletteName) => dispatch(savePaletteAction(breakId, newPaletteName))
});

const SavePaletteMessageConnected = connect(mapStateToProps, mapDispatchToProps);


const SavePaletteMessageComposed = compose(
    SavePaletteMessageConnected
)(SavePaletteMessage);

export default SavePaletteMessageComposed



// WEBPACK FOOTER //
// ./public/components/composites/SavePaletteMessageConnected.jsx